import globalTheme from '../global'

const LinearProgress = {
	MuiLinearProgress: {
		styleOverrides: {
			colorPrimary: { backgroundColor: globalTheme.palette.grey.light },
			barColorPrimary: { backgroundColor: globalTheme.palette.primary.main },
		},
	},
}

export default LinearProgress
